/* eslint-disable import/prefer-default-export */

// project imports
import gestopAPI from 'utils/gestopAPI';
import { errorProcessor } from 'utils/processors';

export const ApiGetSettingsWorkflow = async ({ successCallback, errorCallback, config = {} }) => {
    await gestopAPI
        .get('settings/workflow', config)
        .then((response) => {
            if (typeof successCallback === 'function') {
                successCallback(response?.data);
            }
        })
        .catch((error) => {
            const errorMsg = errorProcessor(error?.response?.data);

            if (typeof errorCallback === 'function') {
                errorCallback(errorMsg);
            }
        });
};
